define('lq/events/actions/popupGoogleLogin',[
    'lq',
    'lq/events/actions/eventAction'
], function (lq, EventAction) {
    'use strict';

    function PopupGoogleLogin(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(PopupGoogleLogin, EventAction);

    PopupGoogleLogin.typeName = 'PopupGoogleLogin';

    PopupGoogleLogin.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    PopupGoogleLogin.prototype.execute = function (continuation) {
        require([ 'https://accounts.google.com/gsi/client' ], this.signIn.bind(this, continuation));
    };

    PopupGoogleLogin.prototype.signIn = function (continuation) {
        this.$popup = $('<div id="googleLoginPopup" />')
            .css({
                position: 'fixed',
                top: '50%',
                left: '50%',
                zIndex: 999999,
                transform: 'translate(-50%, -50%)'
            })
            .appendTo($('body'));

        google.accounts.id.initialize({
            client_id: this.eventData.clientId,
            cancel_on_tap_outside: false,
            prompt_parent_id: 'googleLoginPopup',
            callback: this.handlePopupResponse.bind(this, continuation)
        });

        var self = this;
        google.accounts.id.prompt(function (notification) {
            // OneTap has a cool down feature that will supress the login dialog when the user closed it using 'x'.
            // However, the button does not suffer from this, so we can fallback to showing a button instead
            if (notification.isNotDisplayed()) {
                window.google.accounts.id.renderButton(
                    document.getElementById("googleLoginPopup"),
                    {
                        theme: 'filled_blue',
                        size: 'large'
                    }
                );
            } else if (notification.isSkippedMoment()) {
                self.piping.busyIndicator.forceHide();
            }
        });
    };

    PopupGoogleLogin.prototype.handlePopupResponse = function (continuation, response) {
        if (!response.credential) {
            this.handleError('invalidCredentials', 'Unable to sign in.');
        } else {
            this.piping.dispatcher.dispatch(
                'LicquidAction/GoogleLogin', {
                    actionId: this.piping.actionId,
                    commandId: this.eventData.command,
                    accessToken: response.credential
                }, this.handleLoginResponse.bind(this, continuation));
        }

        this.$popup.remove();
        this.$popup = null;
    };

    PopupGoogleLogin.prototype.handleLoginResponse = function (continuation, result) {
        var self = this;
        if (result.status === 'Success') {
            var returnUrl = this.piping.queryString.getValueOf('ReturnUrl') || lq.getTenantUrl('');

            if (this.eventIsEnabled('updatingUserProperties')) {
                this.refreshCsrfTokenForNewUser(function () {
                    self.triggerEvent('updatingUserProperties', function () {
                        self.piping.dispatcher.dispatch('LicquidAction/RefreshCurrentUser')
                            .then(function () {
                                if (self.isUserLoggedInEventEnabled())
                                    self.triggerUserLoggedInEvents(continuation, returnUrl);
                                else
                                    continuation();
                            });
                    });
                });
            } else if (this.isUserLoggedInEventEnabled()) {
                this.refreshCsrfTokenForNewUser(function () {
                    self.triggerUserLoggedInEvents(continuation, returnUrl);
                });
            } else {
                window.location = lq.safeRedirectUrl(returnUrl, lq.getTenantUrl(''));
            }
        } else if (result.status === 'UserLoginNotAllowed') {
            this.handleError('userLoginNotAllowed',
                'The user is not allowed to log in.',
                continuation);
        } else {
            this.handleError('invalidCredentials', 'Unable to sign in.');
        }
        if (result.eventsToExecute) {
            _.each(result.eventsToExecute, function (eventName) {
                self.piping.eventing.publish(eventName, self.eventSource, null, continuation, null);
            });
        }
    };

    PopupGoogleLogin.prototype.handleError = function (eventName, defaultMessage) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, continuation);
        } else {
            alert(defaultMessage);
        }
    };

    return PopupGoogleLogin;
});
